/**
 * Stock Photos Index
 * Premium stock photos for the Photo Editor
 */

import stock1 from './stock-1.png';
import stock2 from './stock-2.png';
import stock3 from './stock-3.png';
import stock4 from './stock-4.png';
import stock5 from './stock-5.png';
import stock6 from './stock-6.png';
import stock7 from './stock-7.png';
import stock8 from './stock-8.png';
import stock9 from './stock-9.png';
import stock10 from './stock-10.png';
import stock11 from './stock-11.png';
import stock12 from './stock-12.png';
import stock13 from './stock-13.png';
import stock14 from './stock-14.png';
import stock15 from './stock-15.png';
import stock16 from './stock-16.png';
import stock17 from './stock-17.png';

// Stock photos categorized for easy access
export const STOCK_PHOTOS = {
  technology: [
    { id: 'stock-1', name: 'AI Home Tech', src: stock1, category: 'technology' },
    { id: 'stock-3', name: 'AI Home Tech 2', src: stock3, category: 'technology' },
    { id: 'stock-5', name: 'AI Home Tech 3', src: stock5, category: 'technology' },
    { id: 'stock-7', name: 'AI Home Tech 4', src: stock7, category: 'technology' },
  ],
  approval: [
    { id: 'stock-8', name: 'Mortgage Approved', src: stock8, category: 'approval' },
    { id: 'stock-9', name: 'Mortgage Approved 2', src: stock9, category: 'approval' },
    { id: 'stock-10', name: 'Mortgage Approved 3', src: stock10, category: 'approval' },
    { id: 'stock-11', name: 'Mortgage Approved 4', src: stock11, category: 'approval' },
    { id: 'stock-12', name: 'Mortgage Approved 5', src: stock12, category: 'approval' },
  ],
  professional: [
    { id: 'stock-13', name: 'Loan Officer', src: stock13, category: 'professional' },
    { id: 'stock-14', name: 'Loan Officer 2', src: stock14, category: 'professional' },
    { id: 'stock-15', name: 'Loan Officer 3', src: stock15, category: 'professional' },
    { id: 'stock-16', name: 'Loan Officer 4', src: stock16, category: 'professional' },
    { id: 'stock-17', name: 'Loan Officer 5', src: stock17, category: 'professional' },
  ],
  lifestyle: [
    { id: 'stock-2', name: 'Happy Homebuyers', src: stock2, category: 'lifestyle' },
    { id: 'stock-4', name: 'Happy Homebuyers 2', src: stock4, category: 'lifestyle' },
    { id: 'stock-6', name: 'Happy Homebuyers 3', src: stock6, category: 'lifestyle' },
  ],
};

// Flat array of all stock photos
export const ALL_STOCK_PHOTOS = [
  ...STOCK_PHOTOS.technology,
  ...STOCK_PHOTOS.approval,
  ...STOCK_PHOTOS.professional,
  ...STOCK_PHOTOS.lifestyle,
];

export default STOCK_PHOTOS;
